import { auth } from '../firebase'
import {  linkWithCredential, reauthenticateWithCredential, sendSignInLinkToEmail, isSignInWithEmailLink, signInWithEmailLink, EmailAuthProvider } from "firebase/auth";

export default {

   email_settings: { 
      url: 'https://thehappytherapist.com.au/membership',
      handleCodeInApp: true
   },

   async emailLinkSend(email) {
      let result = await sendSignInLinkToEmail(auth, email, this.email_settings);
       
      // The link was successfully sent. Inform the user.
      // Save the email locally so you don't need to ask the user for it again
      // if they open the link on the same device.   

      window.localStorage.setItem('emailForSignIn', email);
      console.log("sendSignInLinkToEmail.success", result);

      return result;
   },

   async emailLinkComplete() {
      // Confirm the link is a sign-in with email link.
      if (isSignInWithEmailLink(auth, window.location.href)) {
         // Additional state parameters can also be passed via URL.
         // This can be used to continue the user's intended action before triggering
         // the sign-in operation.
         // Get the email if available. This should be available if the user completes
         // the flow on the same device where they started it.
         let email = window.localStorage.getItem('emailForSignIn');
         if (email == null || email == undefined) {
            // User opened the link on a different device. To prevent session fixation
            // attacks, ask the user to provide the associated email again. For example:
            email = window.prompt('Please provide your email for confirmation');
         }

         // The client SDK will parse the code from the link for you.
         let result = await signInWithEmailLink(auth, email, window.location.href);
    
         console.log("signInWithEmailLink.success", result);

         // Clear email from storage.
         window.localStorage.removeItem('emailForSignIn');
         // You can access the new user via result.user
         // Additional user info profile not available via:
         // result.additionalUserInfo.profile == null
         // You can check if the user is new or existing:
         // result.additionalUserInfo.isNewUser

         return result;
      }
      throw new Error('Invalid Authorization Url');
   },

   emailLinkLink(email) {
      // Construct the email link credential from the current URL.

      let credential = EmailAuthProvider.credentialWithLink(email, window.location.href);

      // Link the credential to the current user.
      linkWithCredential(auth.currentUser, credential).then((usercred) => {
            // The provider is now successfully linked.
            // The phone user can now sign in with their phone number or email.
         })
         .catch((error) => {
            // Some error occurred.
         });
   },

   emailLinkReauth(email) {
      // Construct the email link credential from the current URL.
      let credential = EmailAuthProvider.credentialWithLink(email, window.location.href);

      // Re-authenticate the user with this credential.
      reauthenticateWithCredential(auth.currentUser, credential)
         .then((usercred) => {
            // The user is now successfully re-authenticated and can execute sensitive
            // operations.
         })
         .catch((error) => {
            // Some error occurred.
         });
   },

   emailLinkDifferentiate() {
      // After asking the user for their email.
      let email = window.prompt('Please provide your email');
      auth.fetchSignInMethodsForEmail(email)
         .then((signInMethods) => {
            // This returns the same array as fetchProvidersForEmail but for email
            // provider identified by 'password' string, signInMethods would contain 2
            // different strings:
            // 'emailLink' if the user previously signed in with an email/link
            // 'password' if the user has a password.
            // A user could have both.
            if (signInMethods.indexOf(EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD) != -1) {
               // User can sign in with email/password.
            }
            if (signInMethods.indexOf(EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD) != -1) {
               // User can sign in with email/link.
            }
         })
         .catch((error) => {
            // Some error occurred, you can inspect the code: error.code
         });
   }
}